import { render, staticRenderFns } from "./ApproversSection.vue?vue&type=template&id=802fa060&"
import script from "./ApproversSection.js?vue&type=script&lang=js&"
export * from "./ApproversSection.js?vue&type=script&lang=js&"
import style0 from "./ApproversSection.vue?vue&type=style&index=0&id=802fa060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports